import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class NewsLetterSubscriptionURLService {

    private baseUrl = `${environment.baseApiUrl}/NewsLetterSubscription`;

    public AddNewsLetterSubscriptionURL(): string {
        return this.baseUrl; // POST /api/Fleet
    }

    public GetNewsLetterSubscriptionListURL(): string {
        return `${this.baseUrl}`; // GET /api/Fleet/get-fleet-list
    }

}
